import { render, staticRenderFns } from "./CreateaAndUpdate.vue?vue&type=template&id=7173a532&scoped=true"
import script from "./CreateaAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateaAndUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173a532",
  null
  
)

export default component.exports